import { Show, createSignal, onMount } from "solid-js";

import { Button } from "@/components/Base/Button/Button";
// import { DialogType } from "@/components/Dialogs/types";
// import { useDialog } from "@/components/Dialogs/useDialog";
import Icon from "@/components/Icon";
import { useRouter } from "@/hooks/useRouter";
import { t } from "@/i18n";
import { getImgurl } from "@/lib/resFolder";
import { deviceInfo } from "@/stores/deviceStore";
import { userStore } from "@/stores/userStore";

export default function AppDownloadBannerH5() {
  //   const { showDialog } = useDialog();
  const { push } = useRouter();
  const [visible, setVisible] = createSignal(false);

  const getTodayKey = () => {
    const d = new Date();
    return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
  };

  onMount(() => {
    const closedDate = localStorage.getItem("appDownloadBannerH5Closed");
    if (closedDate === getTodayKey()) {
      setVisible(false);
      return;
    }

    if (!userStore.isLogin) {
      setVisible(false);
      return;
    }

    if (deviceInfo.app || deviceInfo.pwa) {
      setVisible(false);
      return;
    }

    setVisible(true);
  });

  const handleClose = () => {
    localStorage.setItem("appDownloadBannerH5Closed", getTodayKey());
    setVisible(false);
  };

  //   const handleDownload = () => {
  //     showDialog({ type: DialogType.AppDownloadActivity });
  //     handleClose();
  //   };
  const handleDownload = () => {
    push("/install");
    handleClose();
  };

  return (
    <Show when={visible()} fallback={<></>}>
      <div class="bg-general-bg4 border-general-searchbg fixed bottom-[76px] left-0 right-0 z-[500] mx-[12px] flex flex-col items-center rounded-[10px] border p-[12px] opacity-100">
        {/* <div class="inline-flex w-full justify-between gap-x-[15px]">
          <div></div>
          <Icon
            name="general/xx2"
            class="z-[1] h-[12px] w-[12px] cursor-pointer items-center justify-center rounded-md"
            onClick={handleClose}
          />
        </div> */}

        <div class="flex w-full items-center gap-[8px]">
          <div class="flex items-center gap-[8px]">
            <Icon
              name="general/xx3_activity"
              color="text-[#B3B8C1]"
              class="h-[14px] w-[14px] cursor-pointer rounded-md"
              onClick={handleClose}
            />
            <img
              src={getImgurl("download-h5.png", "activity/appdownload")}
              class="h-[36.4px] w-[40px]"
              alt="app下载"
            />
          </div>

          <div class="text-general-light flex flex-1 flex-col items-start justify-center font-[inter] text-[12px] font-medium leading-[15px]">
            {t("tips.install")}
            <br />
            {t("tips.install_promotions")}
          </div>

          <Button
            variant="primary"
            type="button"
            class="bg-linear-to-r from-(--colors-btn-brand-primary-grt) to-(--colors-btn-brand-primary-glt) flex h-[30px] min-w-[71px] shrink-0 items-center justify-center rounded-[4px] border-0 px-[6px] text-[12px] font-[800] text-[var(--colors-text-brand)]"
            onClick={handleDownload}
          >
            {t("install.download_button")}
          </Button>
        </div>
      </div>
    </Show>
  );
}
